import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import {
  setSymbolActive,
  setSymbolScroll,
} from '../../containers/client/actions';
import DatagridRowLole from './DatagridRowLole';

function DatagridLole(props) {
  const dispatch = useDispatch();

  const { symScroll, resource, children, className, isPc } = props;

  useEffect(() => {
    if (symScroll) {
      // console.log(symScroll)
      scrollTo(symScroll);
      dispatch(setSymbolScroll(null));
    }
  }, [symScroll]);

  const scrollTo = (id) => {
    let _rootRow = document.getElementById(id + 'row');
    if (_rootRow) {
      _rootRow.scrollIntoView();
      _rootRow.classList.add('bg-active');
      setTimeout(() => {
        if (_rootRow) _rootRow.classList.remove('bg-active');
      }, 1500);
    }
  };

  const handleOpenModal = (sym) => {
    dispatch(setSymbolActive(sym));
  };

  return (
    <table className={className + ''}>
      {children && (
        <thead className="bb-1-haft ">{children}</thead>
      )}
      <tbody>
        {resource &&
          !!resource.length &&
          resource.map((item, index) => (
            <DatagridRowLole
              record={item}
              key={`${item.sym}-${index}`}
              handleOpenModal={handleOpenModal}
            />
          ))}
      </tbody>
    </table>
  );
}

const mapStateToProps = (state) => {
  // console.log(state.client)
  return {
    symScroll: state.client.symbolScroll,
  };
};

export default connect(mapStateToProps)(DatagridLole);
